/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { FuturesTradeAccountResponse } from './data-contracts';
import { HttpClient, RequestParams } from './http-client';

export class FuturesTradeAccounts<SecurityDataType = unknown> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @name OptionsFuturesTradeAccounts
   * @request OPTIONS:/futuresTradeAccounts/{id}
   */
  optionsFuturesTradeAccounts = (id: string, params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/futuresTradeAccounts/${id}`,
      method: 'OPTIONS',
      ...params,
    });
  /**
   * No description
   *
   * @name GetFuturesTradeAccounts
   * @request GET:/futuresTradeAccounts
   * @secure
   */
  getFuturesTradeAccounts = (params: RequestParams = {}) =>
    this.request<FuturesTradeAccountResponse, any>({
      path: `/futuresTradeAccounts`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @name OptionsFuturesTradeAccounts2
   * @request OPTIONS:/futuresTradeAccounts
   * @originalName optionsFuturesTradeAccounts
   * @duplicate
   */
  optionsFuturesTradeAccounts2 = (params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/futuresTradeAccounts`,
      method: 'OPTIONS',
      ...params,
    });
}
